

import Main from "../views/main";

const aiFriendManageRoute = {
  path: "/ai-friend",
  component: Main,
  title: "AI女友管理",
  icon: "el-icon-s-custom",
  meta: { keepAlive: true },
  children: [
    {
      path: "/role-manage",
      component: () => import("@/views/aiFriendManage/roleManage/index"),
      name: "AiFriendRoleManage",
      title: "角色管理",
      meta: { title: "角色管理", keepAlive: true },
    },
    {
      path: "/role-tag-manage",
      component: () => import("@/views/aiFriendManage/roleTagManage/index"),
      name: "AiFriendRoleTagManage",
      title: "角色标签",
      meta: { title: "角色标签", keepAlive: true },
    },
    {
      path: "/ai-friend-dialog-list",
      component: () => import("@/views/aiFriendManage/dialogList/index"),
      name: "AiFriendDialogList",
      title: "会话列表",
      meta: { title: "会话列表", keepAlive: true },
    },
    {
      path: "/ai-friend-message-list",
      component: () => import("@/views/aiFriendManage/messageList/index"),
      name: "AiFriendMessageList",
      title: "消息列表",
      meta: { title: "消息列表", keepAlive: true },
    },
    {
      path: "/ai-friend-transaction-list",
      component: () => import("@/views/aiFriendManage/transactionList/index"),
      name: "AiFriendTransactionList",
      title: "积分流水",
      meta: { title: "积分流水", keepAlive: true },
    },
    {
      path: "/ai-friend-product-config",
      component: () => import("@/views/aiFriendManage/productConfig/index"),
      name: "AiFriendProductConfig",
      title: "产品配置",
      meta: { title: "产品配置", keepAlive: true },
    },
    {
      path: "/ai-friend-cost",
      component: () => import("@/views/aiFriendManage/cost/index"),
      name: "AiFriendCost",
      title: "模型成本",
      meta: { title: "模型成本", keepAlive: true },
    },
    // {
    //   path: "/ai-friend-stat",
    //   component: () => import("@/views/aiFriendManage/stat/index"),
    //   name: "AiFriendStat",
    //   title: "每日汇总",
    //   meta: { title: "每日汇总", keepAlive: true },
    // },
  ],
};
export default aiFriendManageRoute;
